export const minAmounts = {
    SEK: 100,
    EUR: 10,
    USD: 11,
    GBP: 9,
    CHF: 10,
    CAD: 15,
    AUD: 17,
    NOK: 118,
    DKK: 75,
    JPY: 1576,
    CNY: 77,
};
